import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-show-pictures-dialog',
    templateUrl: './show-pictures-dialog.component.html',
    styleUrls: ['./show-pictures-dialog.component.scss']
})
export class ShowPicturesDialogComponent implements OnInit {

    public pictures: any[];
    public shownIndex: number = 0;
    public useBlobImage!: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ShowPicturesDialogComponent>) { }

    ngOnInit() {
        this.pictures = this.data.pictures;
        this.shownIndex = this.data.shownIndex;
        this.useBlobImage = this.data.useBlobImage ?? false;
    }

    public browsePictures(direction: string) {
        if (direction === 'before') {
            this.shownIndex -= 1;
        } else {
            this.shownIndex += 1;
        }
    }
}
